<div class="d-flex">

    <div class="left-container">
        <ui-steps-progress [steps]="steps" [stepNumber]="stepNumber"></ui-steps-progress>
    </div>

    <div class="right-container">
        <div class="container">

            <div class="step-container">
                <div class="step-content">
                    <ng-container [ngSwitch]="stepNumber">
                        <!--Company details-->
                        <ng-template [ngSwitchCase]="'1'">
                            <div class="step-text">
                                <h2 class="step-title">Informazioni generali</h2>
                                <span class="step-subtitle">Dati generali della società.</span>
                            </div>
                            <div class="step-form">
                                <form #generalInfo="ngForm" class="row g-3">
                                    <div class="col-md-12">
                                        <label for="company-first-name"
                                               class="form-label required">Ragione sociale</label>
                                        <input type="text" class="form-control" id="company-first-name"
                                               [(ngModel)]="company.name"
                                                required name="company-name"
                                               readonly
                                        />
                                    </div>
                                    <div class="col-md-6">
                                        <label for="company-legal-first-name"
                                               class="form-label required">Nome rappresentante</label>
                                        <input type="text" class="form-control" id="company-legal-first-name"
                                               [(ngModel)]="company.legalFirstName"
                                                required name="company-first-name"
                                               readonly
                                        >
                                    </div>
                                    <div class="col-md-6">
                                        <label for="company-legal-last-name"
                                               class="form-label required">Cognome rappresentante</label>
                                        <input type="text" class="form-control" id="company-legal-last-name"
                                               [(ngModel)]="company.legalLastName"
                                                required name="company-last-name"
                                               readonly
                                        >
                                    </div>
                                    <div class="col-md-6">
                                        <label for="company-vat"
                                               class="form-label required">Partita IVA</label>
                                        <input type="text" class="form-control" id="company-vat"
                                               [(ngModel)]="company.vat"
                                                required name="company-vat"
                                               readonly
                                        >
                                    </div>
                                    <div class="col-md-6">
                                        <label for="company-fiscal-code"
                                               class="form-label required">Codice fiscale</label>
                                        <input type="text" class="form-control" id="company-fiscal-code"
                                               [(ngModel)]="company.fiscalCode"
                                                required name="company-fiscal-code"
                                               readonly
                                        >
                                    </div>
                                    <div class="col-md-12">
                                        <label for="company-address"
                                               class="form-label required">Indirizzo</label>
                                        <input type="text" class="form-control" id="company-address"
                                               [(ngModel)]="company.address"
                                                required name="company-address"
                                               readonly
                                        >
                                    </div>
                                    <div class="col-md-3">
                                        <label for="company-zip"
                                               class="form-label required">CAP</label>
                                        <input type="text" class="form-control" id="company-zip"
                                               [(ngModel)]="company.zip"
                                                required name="company-zip"
                                               readonly
                                        >
                                    </div>
                                    <div class="col-md-6">
                                        <label for="company-city"
                                               class="form-label required">Città</label>
                                        <select class="form-control" id="company-city"
                                                [(ngModel)]="company.city"
                                                required name="company-city"
                                                disabled
                                        >
                                            <option *ngFor="let city of cities"
                                                    value="{{city}}"> {{ city }} </option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <label for="company-province"
                                               class="form-label required">Provincia</label>
                                        <select class="form-control" id="company-province"
                                                [(ngModel)]="company.province"
                                                disabled
                                                (change)="updateCitiesCompany()"
                                                required
                                                name="company-province"
                                        >
                                            <option *ngFor="let province of provinces"
                                                    [value]="province.id"> {{ province.name }} </option>
                                        </select>
                                    </div>
                                        <div class="col-md-12 ">
                                            <span class="col-sm-4 required">Carica fronte carta di identità*</span>
                                            <div class="col-md-12">
                                                <input type="file" class="form-control form-control-solid" id="documentFront"
                                                       aria-describedby="documentFront" aria-label="Upload"
                                                       (change)="chooseDocumentFront($event)" name="documentFront" required >
                                                <div *ngIf="legalDocumentFrontResponse && legalDocumentFrontResponse.success">
                                                    <a [href]="legalDocumentFrontResponse.data">Visualizza il documento caricato</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <span class="col-sm-4 required">Carica retro carta di identità*</span>
                                            <div class="col-md-12">
                                                <input type="file" class="form-control form-control-solid" id="documentBack"
                                                        aria-describedby="documentBack" aria-label="Upload"
                                                        (change)="chooseDocumentBack($event)" name="documentBack" required >
                                                <div *ngIf="legalDocumentBackResponse && legalDocumentBackResponse.success">
                                                    <a [href]="legalDocumentBackResponse.data">Visualizza il documento caricato</a>
                                                </div>      
                                            </div>
                                        </div>
                                </form>
                            </div>
                            <div class="buttons d-flex justify-content-between">
                                <span class="support-contact welldone-text-gray">
                                    Se i dati non dovessero essere corretti, <a href="mailto:support@welldone.com" >contatta il supporto</a>
                                </span>
                                <button class="btn btn-primary"
                                        [disabled]="generalInfo.invalid || !legalDocumentBack || !legalDocumentFront"
                                        (click)="nextStep()">Continua
                                </button>
                            </div>
                        </ng-template>
                        <!-- Email  -->
                        <ng-template [ngSwitchCase]="'2'">
                            <div class="step-text">
                                <h2 class="step-title">Indirizzi notifiche</h2>
                                <span class="step-subtitle">Indirizzi email per la gestione delle notifiche.</span>
                            </div>
                            <div class="step-form">
                                <form #emailsNotification="ngForm" class="row ">
                                    <div class="col-md-12 mb-3">
                                        <label for="sender-email"
                                               class="form-label required">Email di invio </label>
                                        <input type="email" class="form-control" id="sender-email"
                                               [(ngModel)]="company.sendingEmail"
                                                required name="company-send"
                                        />
                                    </div>
                                    <div class="col-md-12">
                                        <label for="receiver-email"
                                               class="form-label required">Email di ricezione</label>
                                        <input type="email" class="form-control" id="receiver-email"
                                               [(ngModel)]="company.receivingEmail"
                                                required name="company-receive">
                                    </div>
                                    <div class="buttons col-md-12">
                                        <div class="btn btn-secondary" *ngIf="stepNumber !== 1"
                                             (click)="previousStep()">
                                            Indietro
                                        </div>
                                        <button class="btn btn-primary"
                                                [disabled]="emailsNotification.invalid"
                                                (click)="nextStep()">Continua
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </ng-template>
                        <!--Soisy-->
                        <!--<ng-template [ngSwitchCase]="'3'">
                            <div class="step-text">
                                <h2 class="step-title">Chiavi Soisy</h2>
                                <span class="step-subtitle">Inserisci le chiavi di configurazione di Soisy</span>
                            </div>
                            <div class="step-form">
                                <form #soisy="ngForm" class="row ">
                                    <div class="col-md-12 mb-3">
                                        <label for="soisy-shop-id"
                                               class="form-label required">Product ID </label>
                                        <input type="email" class="form-control" id="soisy-shop-id"
                                               [(ngModel)]="company.soisyShopId"
                                                required name="soisy-shop-id"
                                        />
                                    </div>
                                    <div class="col-md-12">
                                        <label for="soisy-apiKey"
                                               class="form-label required">Api Key</label>
                                        <input type="email" class="form-control" id="soisy-apiKey"
                                               [(ngModel)]="company.soisyApiKey"
                                                required name="soisy-apiKey">
                                    </div>
                                    <div class="buttons col-md-12 mb-3">
                                        <div class="btn btn-secondary" *ngIf="stepNumber !== 1"
                                             (click)="previousStep()">
                                            Indietro
                                        </div>
                                        <button class="btn btn-primary"
                                                [disabled]="soisy.invalid"
                                                (click)="nextStep()">Continua
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </ng-template>-->
                        <!--Nexi-->
                        <ng-template [ngSwitchCase]="'3'">
                            <div class="step-text">
                                <h2 class="step-title">Procedura</h2>
                                <span class="step-subtitle" style="text-align: justify;">
                                    Per ricevere Shpo ID - Api Key è necessario prenotare la Video Chiamata
                                    con Well Done cliccando sul link che avete ricevuto nella e-mail.
                                    Solo dopo la configurazione di X Pay è possibile attivare il metodo di pagamento.                        
                                </span>
                            </div> <br>
                            <div class="step-text">
                                <h2 class="step-title">Chiavi Nexi</h2>
                                <span class="step-subtitle">Inserisci le chiavi di configurazione di Nexi</span>
                                <span class="step-subtitle">Per procedere all’attivazione di Nexi, <a href="https://www.nexi.it/shop/cart/basket/add/single/p/xpay_pro/m/xpay+pro/a/offerta+xpay+pro/ccode/NEWTEAM60"> clicca qui </a></span>
                            </div>
                            <div class="step-form">
                                <form #nexi="ngForm" class="row ">
                                    <div class="col-md-12 mb-3">
                                        <label for="nexi-shop-id"
                                               class="form-label required">Product ID </label>
                                        <input type="email" class="form-control" id="nexi-shop-id"
                                               [(ngModel)]="company.nexiShopId"
                                                required name="nexi-shop-id"
                                        />
                                    </div>
                                    <div class="col-md-12 mb-3">
                                        <label for="nexi-apiKey"
                                               class="form-label required">Api Key</label>
                                        <input type="email" class="form-control" id="nexi-apiKey"
                                               [(ngModel)]="company.nexiApiKey"
                                                required name="nexi-apiKey">
                                    </div>
                                    <div class="buttons col-md-12">
                                        <div class="btn btn-secondary" *ngIf="stepNumber !== 1"
                                             (click)="previousStep()">
                                            Indietro
                                        </div>
                                        <button class="btn btn-primary"
                                                [disabled]="nexi.invalid"
                                                (click)="nextStep()">Continua
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </ng-template>
                        <!--WireTransfer-->
                        <ng-template [ngSwitchCase]="'4'">
                            <div class="step-text">
                                <h2 class="step-title">Bonifico</h2>
                                <span class="step-subtitle">Inserisci le informazioni necessarie per effettuare il bonifico</span>
                            </div>
                            <div class="step-form">
                                <form #wireTransfer="ngForm" class="row ">
                                    <div class="col-md-12 mb-3">
                                        <label for="iban"
                                               class="form-label required">Iban </label>
                                        <input type="email" class="form-control" id="iban"
                                               [(ngModel)]="company.wireTransferIban"
                                                required name="iban"
                                        />
                                    </div>
                                    <div class="col-md-12 mb-3">
                                        <label for="beneficiary"
                                               class="form-label required">Beneficiario</label>
                                        <input type="email" class="form-control" id="beneficiary"
                                               [(ngModel)]="company.wireTransferBeneficiary"
                                                required name="beneficiary">
                                    </div>
                                    <div class="buttons col-md-12 mb-3">
                                        <div class="btn btn-secondary" *ngIf="stepNumber !== 1"
                                             (click)="previousStep()">
                                            Indietro
                                        </div>
                                        <button class="btn btn-primary"
                                                [disabled]="wireTransfer.invalid"
                                                (click)="boardCompany()">Continua
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </ng-template>

                        <ng-template [ngSwitchCase]="'5'">
                            <div class="step-text">
                                <h2 class="step-title">Congratulazioni!</h2>
                                <span class="step-subtitle">Abbiamo preso in carico la tua registrazione.</span>
                            </div>
                            <div class="notice-card">
                                <div class="notice-icon">
                                    <svg width="42" height="42" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10"
                                              fill="#ffc700"></rect>
                                        <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)"
                                              fill="#ffc700"></rect>
                                        <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)"
                                              fill="#ffc700"></rect>
                                    </svg>
                                </div>
                                <div class="notice-text">
                                    <h4 class="notice-title">In attesa di approvazione!</h4>
                                    <div class="notice-description">Ottimo! Appena la configurazione sarà terminata dai nostri tecnici, vi inoltreremo una conferma con il link di accesso.
                                    </div>
                                </div>
                            </div>
                            <div class="buttons">
                                <div class="btn btn-secondary" (click)="backToLogin()">Vai al login</div>
                            </div>
                        </ng-template>
                    </ng-container>

                </div>
            </div>
        </div>
    </div>
</div>
